import { Icon, NotificationBadge } from '@graftcode/design-system'

import { NOTIFICATION_TYPE } from '../notification-drawer.const'
import type { NotificationIconConfig } from '../notification-drawer.interface'
import type { NotificationType } from '../notification-drawer.type'

const iconConfigByType: Record<NotificationType, NotificationIconConfig> = {
  [NOTIFICATION_TYPE.NEW_PACKAGE_VERSION]: {
    icon: Icon.BoxRegular,
    badge: NotificationBadge.New,
  },
  [NOTIFICATION_TYPE.DEPRECATED_PACKAGE]: {
    icon: Icon.BoxRegular,
    badge: NotificationBadge.Warning,
  },
  [NOTIFICATION_TYPE.VULNERABILITY_DETECTED]: {
    icon: Icon.ShieldKeyholeRegular,
    badge: NotificationBadge.Warning,
  },
  [NOTIFICATION_TYPE.HIGH_LATENCY_ALERT]: {
    icon: Icon.DSService,
    badge: NotificationBadge.Warning,
  },
  [NOTIFICATION_TYPE.CONNECTION_ERROR]: {
    icon: Icon.PlugConnectedRegular,
    badge: NotificationBadge.Error,
  },
  [NOTIFICATION_TYPE.SERVICE_DEGRADED]: {
    icon: Icon.DSService,
    badge: NotificationBadge.Warning,
  },
  [NOTIFICATION_TYPE.SCHEDULED_MAINTENANCE]: {
    icon: Icon.WrenchScrewdriverRegular,
  },
  [NOTIFICATION_TYPE.CRITICAL_VULNERABILITY]: {
    icon: Icon.ShieldKeyholeRegular,
    badge: NotificationBadge.Error,
  },
  [NOTIFICATION_TYPE.UNAUTHORIZED_LOGIN]: {
    icon: Icon.ShieldKeyholeRegular,
    badge: NotificationBadge.Warning,
  },
  [NOTIFICATION_TYPE.CERTIFICATE_UPDATE]: {
    icon: Icon.LockClosedRegular,
    badge: NotificationBadge.Warning,
  },
  [NOTIFICATION_TYPE.INVITED_TO_ORGANIZATION]: {
    icon: Icon.MailReadRegular,
    badge: NotificationBadge.New,
  },
  [NOTIFICATION_TYPE.ROLE_PERMISSION_CHANGE]: {
    icon: Icon.KeyRegular,
  },
  [NOTIFICATION_TYPE.NEW_FEATURE]: {
    icon: Icon.MegaphoneRegular,
  },
  [NOTIFICATION_TYPE.SYSTEM_ANNOUNCEMENT]: {
    icon: Icon.ChannelRegular,
    badge: NotificationBadge.New,
  },
  [NOTIFICATION_TYPE.DAILY_DIGEST]: {
    icon: Icon.CalendarRegular,
  },
  [NOTIFICATION_TYPE.WEEKLY_REPORT]: {
    icon: Icon.DataHistogramRegular,
  },
}

export const getNotificationIconConfig = (type: NotificationType): NotificationIconConfig => iconConfigByType[type]
